import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import { useEffect, useState } from "preact/hooks";
import SVGIcon from "../SVGIcon";
import cx from "classnames";

import { ITableColumns } from "../Table";

interface ITableHead {
  columns: ITableColumns[];
  handleSorting;
  currentFilter;
}

const TableHead: FunctionComponent<ITableHead> = ({ columns, handleSorting, currentFilter }) => {
  const [sortField, setSortField] = useState("aerRate");
  const [order, setOrder] = useState("desc");

  const handleSortingChange = (accessor) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);
    handleSorting(accessor, sortOrder);
  };

  return (
    <thead class="table__head">
      <tr>
        {columns.map(({ label, accessor, hiddenOn, shownOn }) => {
          const isSorted = sortField === accessor;
          const isHidden = currentFilter == hiddenOn || (shownOn != null && currentFilter != shownOn);
          const icon = isSorted && order === "asc" ? "down" : isSorted && order === "desc" ? "up" : "default";
          if (!isHidden) {
            return (
              <th
                key={accessor}
                className="table-label"
                onClick={() => handleSortingChange(accessor)}
              >
                <div class="table__head--cell">
                  <div class="table__head--title">{label}</div>
                  <div class="table__head--icons">
                    <SVGIcon
                      name={`chevron--up`}
                      className={cx("chevron-icon", `chevron-icon--up`, "icon--xs", {
                        invisible: isSorted && icon === "up",
                      })}
                    />
                    <SVGIcon
                      name={`chevron--down`}
                      className={cx("chevron-icon", `chevron-icon--down`, "icon--xs", {
                        invisible: isSorted && icon === "down",
                      })}
                    />
                  </div>
                </div>
              </th>
            );
          }
        })}
      </tr>
    </thead>
  );
};

export default TableHead;
